import { Center } from '@chakra-ui/react';
interface ProfileHeaderProps {
    headerImage: string;
}
export default function Header(props: ProfileHeaderProps) {
    return (
        <Center
            className="profileHeader"
            bgGradient="linear(to-tr, brand.500, #4EB5FF)"
            style={{
                overflow: 'hidden'
            }}
        >
            {/* <Image src={headerImage} /> */}
        </Center>
    );
}
